// 独立画布默认不向旧站 TLS 项目发送埋点；保留同名接口以兼容迁移组件。
const noop = () => undefined;

const LogService = new Proxy(
  {
    logPageView: noop,
    logPageLeave: noop,
    logButtonClick: noop,
    logCustomEvent: noop,
    logDropdownClick: noop
  },
  {
    get(target, property) {
      return target[property] || noop;
    }
  }
);

export default LogService;
